import * as actions from 'actions';
import pagingMaker from 'reducersMakers/pagingMaker';

export default pagingMaker({
  fetchType: actions.MAIL_THREADS_FETCH,
  fetchSuccessType: actions.MAIL_THREADS_FETCH_SUCCESS,
  fetchErrorType: actions.MAIL_THREADS_FETCH_ERROR,
  possiblePageUpdateType: actions.MAIL_THREADS_UPDATE_POSSIBLE_PAGE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/paging/mailThreads/reducer.js
 **/